import React from "react";

export const AppLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-[400px] bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-200 border-t-blue-600 mx-auto"></div>
        <p className="mt-6 text-lg text-gray-700 font-semibold">
          Učitavanje kataloga...
        </p>
        <p className="mt-2 text-sm text-gray-500">
          Molimo sačekajte dok se stranica učitava
        </p>
      </div>
    </div>
  );
};
